import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { ReportService } from "../../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../../shared/report-file-type-dialog/report-file-type-dialog.component";
import { ClassAttendanceStudentHistoryRequest } from "../shared/ClassAttendanceStudentHistoryRequest";
import { DataService_Student_Class_Attendance } from "../shared/data.service";
import { ViewClassAttendanceHistoryComponent } from "./view-class-attendance-history/view-class-attendance-history.component";
import * as moment from "moment";

@Component({
	selector: "caass-class-attendance-history-table",
	templateUrl: "./class-attendance-history-table.component.html",
	styleUrls: ["./class-attendance-history-table.component.css"],
})
export class ClassAttendanceHistoryTableComponent implements OnInit {
	constructor(
		private userService: UserService,
		private ClassAttendanceTableService: DataService_Student_Class_Attendance,
		private dialogService: DialogService,
		private reportService: ReportService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadClassAttendanceStudentHistory();
	}

	ngOnChanges() {
		this.errorMessage = "";
		this.loadClassAttendanceStudentHistory();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedPerson: any;
	@Input() SelectedEntry: any;

	isProcessing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedClassAttendanceStudentHistory: any;
	lstClassAttendanceStudentHistory: any = [];

	//Filter lists
	lstClassAttendanceStatusDesc: any = [];
	lstClassAttendanceExcuseDesc: any = [];
	lstClassAttendanceEntryTypeDesc: any = [];
	lstc_PersonTypeDesc: any = [];
	lstc_PersonTitle: any = [];
	lstRecordStatusDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'c_date', header: 'Date/Time' },
		{ field: "DateDesc", header: "Date/Time" },
		{ field: "ClassAttendanceStatusDesc", header: "Status" },
		{ field: "ClassAttendanceExcuseDesc", header: "Excuse" },
		{ field: "ClassAttendanceEntryTypeDesc", header: "Entry Method" },
		{ field: "c_PersonName", header: "Created By" },
		{ field: "c_PersonTypeDesc", header: "Person Type" },
		{ field: "c_PersonTitle", header: "Person Title" },
		{ field: "RecordStatusDesc", header: "Record Status" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadClassAttendanceStudentHistory() {
		this.loading = true;

		if (this.SelectedPerson == undefined || this.SelectedEntry == undefined) {
			this.lstClassAttendanceStudentHistory = [];

			this.loading = false;
			return;
		}

		let parms: ClassAttendanceStudentHistoryRequest = {
			ClassAttendanceStudentID: this.SelectedEntry.ClassAttendanceStudentID,
		};

		var result = this.ClassAttendanceTableService.ClassAttendanceStudentHistoryInfoGetList(parms);
		result.subscribe(
			(response) => {
				this.lstClassAttendanceStudentHistory = response;

				for (var i = 0; i < this.lstClassAttendanceStudentHistory.length; i++) {
					var next = this.lstClassAttendanceStudentHistory[i];

					next.DateDesc = moment(new Date(next.c_date)).format("MM/DD/YYYY h:mm a");
				}

				//Load Data Filter Lists
				this.lstClassAttendanceStatusDesc = Array.from(
					new Set(this.lstClassAttendanceStudentHistory.map((item: any) => item.ClassAttendanceStatusDesc))
				).sort();
				this.lstClassAttendanceExcuseDesc = Array.from(
					new Set(this.lstClassAttendanceStudentHistory.map((item: any) => item.ClassAttendanceExcuseDesc))
				).sort();
				this.lstClassAttendanceEntryTypeDesc = Array.from(
					new Set(this.lstClassAttendanceStudentHistory.map((item: any) => item.ClassAttendanceEntryTypeDesc))
				).sort();
				this.lstc_PersonTypeDesc = Array.from(new Set(this.lstClassAttendanceStudentHistory.map((item: any) => item.c_PersonTypeDesc))).sort();
				this.lstc_PersonTitle = Array.from(new Set(this.lstClassAttendanceStudentHistory.map((item: any) => item.c_PersonTitle))).sort();
				this.lstRecordStatusDesc = Array.from(new Set(this.lstClassAttendanceStudentHistory.map((item: any) => item.RecordStatusDesc))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadClassAttendanceStudentHistory();
	}

	//Custom Button Methods
	onViewHistory() {
		this.errorMessage = "";

		var ref = this.dialogService.open(ViewClassAttendanceHistoryComponent, {
			header: "View History",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedPerson: this.SelectedPerson,
				SelectedEntry: this.SelectedEntry,
				SelectedHistory: this.SelectedClassAttendanceStudentHistory,
			},
		});
		ref.onClose.subscribe((response) => {
			this.onRowUnselect(null);
			// if (response == 1)
			// {
			//   this.onRowUnselect(null);
			//   this.loadClassAttendanceStudentHistory();
			// }
		});
	}

	onPrintHistory() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedEntry == undefined) {
			this.errorMessage = "Select a class attendance record to print its history";
		}

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(FileTypeID) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		this.errorMessage = "";

		var strParam = "";

		/////////////////////////////////
		// Old Method
		/////////////////////////////////

		//
		//Params from filtering:
		//

		//var Semester = "%%";
		//var SectionNo = "%%";
		//var CourseNo = "%%";

		//Parameter 1: PersonID
		//strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: Semester
		//strParam += "," + Semester + "|Semester";

		//Parameter 3: SectionNo
		//strParam += "," + SectionNo + "|SectionNo";

		//Parameter 4: CourseNo
		//strParam += "," + CourseNo + "|CourseNo";

		//Parameter 5: Entry Date
		//strParam += "," + moment(this.SelectedEntry.EntryDate).format("MM/DD/YYYY") + "|EntryDate";

		/////////////////////////////////

		/////////////////////////////////
		// New Method
		/////////////////////////////////

		strParam += this.SelectedEntry.ClassAttendanceStudentID + "|ClassAttendanceStudentID";

		/////////////////////////////////

		var reportID: any = 411;

		//Add type selector (Also have to change report to use class attendance id as param)
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, FileTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedClassAttendanceStudentHistory = val.data;
	}
	onRowUnselect(val) {
		this.SelectedClassAttendanceStudentHistory = null;
	}
	onRowDblClick(ClassAttendanceStudentHistory) {
		this.SelectedClassAttendanceStudentHistory = ClassAttendanceStudentHistory;
		this.onViewHistory();
	}
	////////////////////////////////////////////
}
